import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
  standalone: true,
  imports: [TranslateModule],
})
export class BaseComponent {
  protected translate: TranslateService = inject(TranslateService);

  currentLang: 'ar' | 'en' = 'ar';

  get currentDir(): 'rtl' | 'ltr' {
    if (!this.translate.currentLang) {
      return 'rtl';
    }

    return this.translate.currentLang === 'ar' ? 'rtl' : 'ltr';
  }
}
